/**
 * 五行計算器 — 移植自 LINE bot
 * 根據出生年月日時計算八字命造和五行分數
 */
import { Solar } from 'lunar-javascript';

// 天干對應五行
const TIANGAN_WUXING = {
  '甲': '木', '乙': '木',
  '丙': '火', '丁': '火',
  '戊': '土', '己': '土',
  '庚': '金', '辛': '金',
  '壬': '水', '癸': '水',
};

// 地支對應五行
const DIZHI_WUXING = {
  '子': '水', '丑': '土', '寅': '木', '卯': '木',
  '辰': '土', '巳': '火', '午': '火', '未': '土',
  '申': '金', '酉': '金', '戌': '土', '亥': '水',
};

// 五行 emoji
export const WUXING_EMOJI = {
  '木': '🌳', '火': '🔥', '土': '⛰️', '金': '⚡', '水': '💧',
};

// 五行顏色 (Ant Design 用)
export const WUXING_COLORS = {
  '木': '#52c41a', '火': '#f5222d', '土': '#faad14', '金': '#d4af37', '水': '#1890ff',
};

/**
 * 計算八字命造和五行分數
 * @param {number} year
 * @param {number} month (1-12)
 * @param {number} day (1-31)
 * @param {number} hour (0-23)
 */
export function calculateWuxing(year, month, day, hour) {
  const solar = Solar.fromYmdHms(year, month, day, hour, 0, 0);
  const lunar = solar.getLunar();
  const pillars = lunar.getBaZi(); // [年柱, 月柱, 日柱, 時柱]

  const [yearGZ, monthGZ, dayGZ, hourGZ] = pillars;

  const bazi = {
    year: { tiangan: yearGZ[0], dizhi: yearGZ[1], full: yearGZ },
    month: { tiangan: monthGZ[0], dizhi: monthGZ[1], full: monthGZ },
    day: { tiangan: dayGZ[0], dizhi: dayGZ[1], full: dayGZ },
    hour: { tiangan: hourGZ[0], dizhi: hourGZ[1], full: hourGZ },
  };

  // 計算五行分數
  const scores = { '木': 0, '火': 0, '土': 0, '金': 0, '水': 0 };
  const pillarList = [bazi.year, bazi.month, bazi.day, bazi.hour];
  pillarList.forEach((p) => {
    scores[TIANGAN_WUXING[p.tiangan]] += 2;
    scores[DIZHI_WUXING[p.dizhi]] += 2;
  });

  // 分析強弱
  const elements = Object.keys(scores);
  const maxScore = Math.max(...elements.map((e) => scores[e]));
  const minScore = Math.min(...elements.map((e) => scores[e]));
  const avgScore = elements.reduce((s, e) => s + scores[e], 0) / 5;

  const strongest = elements.filter((e) => scores[e] === maxScore && scores[e] >= avgScore * 1.3);
  const weakest = elements.filter((e) => scores[e] === minScore && scores[e] <= avgScore * 0.7);

  return {
    bazi,
    scores,
    analysis: { strongest, weakest },
  };
}

export default calculateWuxing;
